class VwKurumsozlesmeDTO {
    kurumid?: number = null;
    kurumadi?: string = "";
    ihaleNo?: string = "";
    katsayi?: number = null;
    sozlesmeNo?: string = "";
    sozlesmeturuid?: number = null;
    puantoplam?: number = null;
    kullanilanpuan?: number = null;
    kalanpuan?: number = null;
    tarifetanimid?: number = null;
    kurumtarifeid?: number = null;
    baslangictarih?: string = null;
    bitistarih?: string = null;
};
export default VwKurumsozlesmeDTO;